module.exports = __webpack_public_path__ + "img/cloth_test_thumb.b9808ff6.jpg";